import React from "react";
import PriceCard from "../PriceCard";
import styled from "styled-components";
import AnimatedShapes from "../AnimatedShapes";

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

const Price = () => {
  return (
    <Container id="Pricing">
      <PriceCard />
      <AnimatedShapes />
    </Container>
  );
};

export default Price;
